var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath3Short(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 15,
    viewBox: "0 0 246 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6414 5.66397C88.8887 -0.476613 163.024 -0.226363 234.988 5.5755C248.695 6.68061 207.6 8.75146 193.877 9.20646C171.084 9.96223 148.279 9.4839 125.481 9.20646C123.122 9.17775 120.787 8.37002 118.428 8.28828C98.9827 7.61435 79.5282 7.70237 60.0844 6.93996C49.1828 6.51249 38.3016 5.15436 27.4001 4.71899C19.7599 4.41387 12.1138 4.52888 4.47207 4.71899C3.46524 4.74404 0.472648 5.34726 1.47955 5.36385C28.5761 5.81018 55.6845 4.8643 82.7726 6.00874C94.2728 6.49461 105.689 9.3381 117.179 10.252C161.419 13.771 201.751 15.8551 245.26 10.3103",
    stroke: "#2350F1",
    strokeWidth: 1.57316
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath3Short);
export default __webpack_public_path__ + "static/media/Path-3-short.ee5c13ecc75b44596df5a311706acc32.svg";
export { ForwardRef as ReactComponent };